type AorLike = {
  id: string;
  name: string;
  parent_item_id?: string | null;
};

/** Ids of `aorId` and every AOR nested under it (`parent_item_id` stores the parent's `id`). */
export function collectAorDescendantIds(
  aors: AorLike[],
  aorId: string
): Set<string> {
  const childrenByParent = new Map<string, string[]>();
  for (const aor of aors) {
    if (!aor.parent_item_id) continue;
    const siblings = childrenByParent.get(aor.parent_item_id) ?? [];
    siblings.push(aor.id);
    childrenByParent.set(aor.parent_item_id, siblings);
  }
  const seen = new Set<string>([aorId]);
  const stack = [aorId];
  while (stack.length > 0) {
    const current = stack.pop() as string;
    for (const child of childrenByParent.get(current) ?? []) {
      if (seen.has(child)) continue;
      seen.add(child);
      stack.push(child);
    }
  }
  return seen;
}

/**
 * Options a user may pick as the parent of `aorId`: every other AOR in the group except the AOR itself and its
 * descendants (which would create a cycle). Sorted by name.
 */
export function buildAorParentOptions(
  aors: AorLike[],
  aorId: string | null
): Array<{ label: string; value: string }> {
  const excluded = aorId ? collectAorDescendantIds(aors, aorId) : new Set<string>();
  return aors
    .filter((aor) => !excluded.has(aor.id))
    .map((aor) => ({ label: aor.name, value: aor.id }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
